module.exports = __webpack_public_path__ + "static/afilias-logo-6774ee14b045643c7eca81a6ba1e85cb.png";